import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axiosClient from "@service/axiosClient";
import { useTranslation } from "react-i18next";

import UserProfileCardNew from "@components/user_profile/UserProfileCardNew";
import "./Profile.css";

export const ProfileNew = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [stub, setStub] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userResponse = await axiosClient.get(`/api/user/${id}`);

        setUser(userResponse.data);

        // Try fetching the stub, but handle the case if it doesn't exist
        try {
          const stubResponse = await axiosClient.get(
            `/api/user/${id}/latest_stub`
          );
          setStub(stubResponse.data);
        } catch (stubError) {
          console.warn("No stub data found or stub API error:", stubError);
          setStub(null); // Set stub to null or some default value if no stub is found
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [id]);

  // Return loading text if user data is still being fetched
  if (!user) {
    return <div>{t("profile.loading")}</div>;
  }

  return (
    <div className="user-view">
      <div>
        <UserProfileCardNew prop={user} stub={stub} isAuthorized={false} />
      </div>
    </div>
  );
};
